import { DateInput, TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Grid } from '@material-ui/core';
import { SelectCliente } from 'app/components/Select';
import { useFormikContext } from 'formik';
import React from 'react';
import SelectTransportadora from '../../../../components/Select/SelectTransportadora';
import SelectVendedor from '../../../../components/Select/SelectVendedor';

const onlyNumberRegex = /^\d*$/;

const VendaBuscaAvancadaForm = () => {
  const formik = useFormikContext();
  const _errors = {};
  
  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextInput
          id="identificador"
          name="identificador"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.identificador}
          maxLength={3}
          fullWidth
          variant="outlined"
          label="Identificador"
          pattern={onlyNumberRegex}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
      <DateInput
          fullWidth
          id="data"
          label="Data"
          value={formik.values?.data || null}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={!!_errors.data}
          helperText={_errors.data}
        />
      </Grid>
      
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectCliente
          id="cliente"
          name="cliente"
          label="Cliente"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.cliente}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <SelectInput
            id="situacao"
            name="situacao"
            label="Situação"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values?.situacao}
            error={_errors?.situacao}
            touched={!!_errors?.situacao}              
            options={[
                { id: 'EM_ORCAMENTO', title: 'Em orçamento' },
                { id: 'VENDA_APROVADA', title: 'Venda aprovada' },
                { id: 'ORCAMENTO_RECUSADO', title: 'Orçamento recusado' },
              ]}
      />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectTransportadora
          id="transportadora"
          fullWidth
          label="Transportadora"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.transportadora}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectVendedor
          id="vendedor"
          fullWidth
          label="Vendedor"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.vendedor}
        />
      </Grid>

    </Grid>
  )
}

export default VendaBuscaAvancadaForm;
